import { render } from "./WalletSelector.vue?vue&type=template&id=aa57fca6"
import script from "./WalletSelector.vue?vue&type=script&lang=js"
export * from "./WalletSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Input/WalletSelector.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aa57fca6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa57fca6', __exports__)) {
    api.reload('aa57fca6', __exports__)
  }
  
  module.hot.accept("./WalletSelector.vue?vue&type=template&id=aa57fca6", () => {
    api.rerender('aa57fca6', render)
  })

}


export default __exports__